import { render, staticRenderFns } from "./workerImg.vue?vue&type=template&id=81a68c6e&scoped=true&"
import script from "./workerImg.vue?vue&type=script&lang=js&"
export * from "./workerImg.vue?vue&type=script&lang=js&"
import style0 from "./workerImg.vue?vue&type=style&index=0&id=81a68c6e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a68c6e",
  null
  
)

export default component.exports